import { render, staticRenderFns } from "./EditorTiptapComponent.vue?vue&type=template&id=1140e792&"
import script from "./EditorTiptapComponent.vue?vue&type=script&lang=js&"
export * from "./EditorTiptapComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditorTiptapComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports